(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('appraisal-scrub', {
            parent: 'entity',
            url: '/appraisal-order/{orderId}/scrub',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.appraisalScrub.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraisal-scrub/appraisal-scrubs.html',
                    controller: 'AppraisalScrubController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                orderId: ['$stateParams', function ($stateParams) {
                    return $stateParams.orderId;
                }],
                versions: ['$stateParams', 'AppraisalScrub', function ($stateParams, AppraisalScrub) {
                    return AppraisalScrub.getByOrder({ orderId: $stateParams.orderId }).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalScrub');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
